<template>
  <el-dialog v-bind="$attrs"
             v-on="$listeners"
             title=""
             class="share-dialog">
    <div slot="title">{{$t('common.share')}}
      <hr class="border-t-1 border-t-solid border-t-gray absolute left-0 w-full h-3 my-4"/>
    </div>
    <div class="flex flex-col items-center justify-center widget-job-share_modal__wrapper">
      <span class="text-xl mb-4 text-primary-opaque widget-job-share_modal__header">{{$t('components.share.header')}}</span>
      <el-input class="widget-job-share_modal__copy-input" :value="jobLink"></el-input>
      <el-button class="mt-4 widget-job-share_modal__copy-button" @click="copyLink(jobLink)">
        <copy-icon size="1x" class="mr-1 custom-class"></copy-icon>
        <span v-if="!copied">{{$t('components.share.copyLink')}}</span><span v-if="copied">{{$t('components.share.copied')}}</span>
      </el-button>
      <hr class="border-t-1 border-t-solid border-t-gray w-full h-3 my-4 widget-job-share_modal__divider"/>
      <span class="text-lg text-primary-opaque widget-job-share_modal__social">{{$t('components.share.socialNetworks')}}</span>
      <SocialShareIcons
        :title="job.title"
        :description="job.description"
        :hash-tags="segmentsText"
        class="mt-6 widget-job-share_modal_social-share__wrapper"/>
    </div>
  </el-dialog>
</template>

<script>
  import Vue from 'vue'
  import SocialSharing from 'vue-social-sharing'
  import SocialShareIcons from '../SocialShareIcons'
  import { CopyIcon } from 'vue-feather-icons'

  Vue.use(SocialSharing)

  export default {
    name: 'share-modal',
    components: { CopyIcon, SocialShareIcons },
    props: {
      job: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      segmentsText() {
        let { segments } = this.job
        const allSegments = []

        for (const category in segments) {
          const categorySegments = segments[category]
          categorySegments.forEach(segmentId => {
            const segmentInfo = this.$store.getters['getSegmentsById'][segmentId]
            if (segmentInfo) {
              allSegments.push(segmentInfo.value)
            }
          })
        }
        return allSegments.slice(0, 5).toString()
      }
    },
    data() {
      return {
        copied: false,
        jobLink: window.location.href
      }
    },
    methods: {
      copyLink(value) {
        const input = document.createElement('input')
        input.setAttribute('value', value)
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.copied = true
      },
      handleClose() {
        this.$emit('closeModal')
      }
    }
  }
</script>

<style lang="scss">
  .share-dialog {
    .el-dialog {
      position: absolute;
      bottom: 0;
      @screen md {
        position: relative;
      }
    }
  }
</style>
